import React, { useEffect, useState } from "react";
import Tabs from "../common/Tabs";
import TabPanel from "../common/TabPanel";
import RegisterItem from "./RegisterItem";
import EstimateItem from "./EstimateItem";
import CompleteItem from "./CompleteItem";
import { motion } from "framer-motion";
import styled from "styled-components";
import { isEmpty } from "lodash";

interface ApprovalTabData {
  registerNum: number;
  estimateNum: number;
  completeNum: number;
}

const ApprovalListItem = (props: ApprovalTabData) => {
  const sessionHomeTab = window.sessionStorage.getItem("homeTab");

  const [openTab, setOpenTab] = useState<number>();

  const tab = [
    `접수(${props.registerNum > 10 ? "10+" : props.registerNum})`,
    `견적서(${props.estimateNum > 10 ? "10+" : props.estimateNum})`,
    `완료보고(${props.completeNum > 10 ? "10+" : props.completeNum})`,
  ];
  const tabItem: any = {
    0: <RegisterItem />,
    1: <EstimateItem />,
    2: <CompleteItem />,
  };

  useEffect(() => {
    setOpenTab(0);
  }, []);

  useEffect(() => {
    if (!isEmpty(sessionHomeTab) && typeof sessionHomeTab !== undefined) {
      setOpenTab(Number(sessionHomeTab));
    }
  }, [sessionHomeTab]);

  const tabHandler = (idx: number) => {
    setOpenTab(idx);
  };

  return (
    <Tabs>
      <ul className="white">
        {tab.map((v, idx) => {
          return (
            <li
              className={openTab === idx ? "active" : ""}
              key={idx}
              onClick={() => {
                tabHandler(idx);
              }}
            >
              {v}
              {idx === openTab ? <UnderLine className="underline" layoutId="underline" /> : null}
            </li>
          );
        })}
      </ul>
      <TabPanel type="scroll">{tabItem[openTab!]}</TabPanel>
    </Tabs>
  );
};

const UnderLine = styled(motion.div)`
  ${/* tab 애니효과 */ ""}
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background: #fff;
`;

export default ApprovalListItem;
